import { App } from './ui/app.js';

void new App().boot();
